import { render, staticRenderFns } from "./CorrectIcon.vue?vue&type=template&id=5668080a&scoped=true&"
import script from "./CorrectIcon.vue?vue&type=script&lang=js&"
export * from "./CorrectIcon.vue?vue&type=script&lang=js&"
import style0 from "./CorrectIcon.vue?vue&type=style&index=0&id=5668080a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668080a",
  null
  
)

component.options.__file = "CorrectIcon.vue"
export default component.exports